import { render, staticRenderFns } from "./CartItemCard.vue?vue&type=template&id=c7a8048c&scoped=true&"
import script from "./CartItemCard.vue?vue&type=script&lang=js&"
export * from "./CartItemCard.vue?vue&type=script&lang=js&"
import style0 from "./CartItemCard.vue?vue&type=style&index=0&id=c7a8048c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c7a8048c",
  null
  
)

export default component.exports